import { render } from "./DesktopRow.vue?vue&type=template&id=3ca931a6"
import script from "./DesktopRow.vue?vue&type=script&lang=js"
export * from "./DesktopRow.vue?vue&type=script&lang=js"

import "./DesktopRow.vue?vue&type=style&index=0&id=3ca931a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__